import { render, staticRenderFns } from "./wingInfo.vue?vue&type=template&id=4723ffc7&"
import script from "./wingInfo.vue?vue&type=script&lang=js&"
export * from "./wingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports